/**
 * Applies the "Theme" setting (Settings > Appearance) by toggling Tailwind's
 * `dark` class on <html>. "System" resolves via prefers-color-scheme and
 * stays live while that option is selected. Call `initTheme()` once at boot,
 * before first paint, so there's no flash of the wrong theme.
 */
import { useSettingsStore, getSettingValue } from "./settingsStore";

const DARK_MEDIA_QUERY = "(prefers-color-scheme: dark)";

function resolveIsDark(theme: unknown): boolean {
  if (theme === "dark") return true;
  if (theme === "light") return false;
  return window.matchMedia(DARK_MEDIA_QUERY).matches; // "system" or unset
}

function applyTheme(): void {
  const theme = getSettingValue("appearance", "theme");
  document.documentElement.classList.toggle("dark", resolveIsDark(theme));
}

export function initTheme(): void {
  applyTheme();
  useSettingsStore.subscribe(applyTheme);
  window.matchMedia(DARK_MEDIA_QUERY).addEventListener("change", applyTheme);
}
